export default class ExtensionCategoryQuestionAnswerModel {
  public extensionCategoryQuestionAnswerId: string = ''
  public extensionCategoryQuestionId: string = ''
  public extensionInvestigationId: string = ''
  public notes: string = ''

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data)
    }
  }
}
